import { DEFAULT_LAYER_ZINDEX } from '../constants/Layers';
import BoxReveal from '../presets/text/BoxReveal';
import Cut from '../presets/text/Cut';
import CutWords from '../presets/text/CutWords';
import DebugText from '../presets/text/DebugText';
import FadeText from '../presets/text/FadeText';
import GradientBox from '../presets/text/GradientBox';
import Highlighter from '../presets/text/Highlighter';
import LowerThirds from '../presets/text/LowerThirds';
import OverUnder from '../presets/text/OverUnder';
import PopText from '../presets/text/PopText';
import Quote from '../presets/text/Quote';
import Scrolling from '../presets/text/Scrolling';
import SideLine from '../presets/text/SideLine';
import Swipe, { SwipeDirections } from '../presets/text/Swipe';
import Stacked from '../presets/text/Stacked';
import TopLine from '../presets/text/TopLine';
import WordBlock from '../presets/text/WordBlock';
import Zoom from '../presets/text/Zoom';
import PresetMedia from './PresetMedia';

export const textAnimations = {
  cut: 'cut',
  debug: 'debug',
  fade: 'fade',
  wordblock: 'wordblock',
  highlighter: 'highlighter',
  gradientbox: 'gradientbox',
  boxreveal: 'boxreveal',
  scrolling: 'scrolling',
  cutwords: 'cutwords',
  overunder: 'overunder',
  lowerthirds: 'lowerthirds',
  sideline: 'sideline',
  topline: 'topline',
  stacked: 'stacked',
  pop: 'pop',
  quote: 'quote',
  swipedown: 'swipedown',
  swipeleft: 'swipeleft',
  swiperight: 'swiperight',
  swipeup: 'swipeup',
  zoom: 'zoom',
};
export default class TextMedia extends PresetMedia {
  constructor(model, app) {
    super(model, app);
    this.container.zIndex = model.zIndex || DEFAULT_LAYER_ZINDEX;
  }

  createPreset(model) {
    let preset = null;

    switch (model.animationPreset) {
      case textAnimations.boxreveal:
        preset = new BoxReveal(this.app);
        break;
      case textAnimations.cutwords:
        preset = new CutWords(this.app);
        break;
      case textAnimations.fade:
        preset = new FadeText(this.app);
        break;
      case textAnimations.gradientbox:
        preset = new GradientBox(this.app);
        break;
      case textAnimations.highlighter:
        preset = new Highlighter(this.app);
        break;
      case textAnimations.lowerthirds:
        preset = new LowerThirds(this.app);
        break;
      case textAnimations.overunder:
        preset = new OverUnder(this.app);
        break;
      case textAnimations.pop:
        preset = new PopText(this.app);
        break;
      case textAnimations.quote:
        preset = new Quote(this.app);
        break;
      case textAnimations.scrolling:
        preset = new Scrolling(this.app);
        break;
      case textAnimations.sideline:
        preset = new SideLine(this.app);
        break;
      case textAnimations.stacked:
        preset = new Stacked(this.app);
        break;
      case textAnimations.topline:
        preset = new TopLine(this.app);
        break;
      case textAnimations.wordblock:
        preset = new WordBlock(this.app);
        break;
      case textAnimations.swipedown:
        preset = new Swipe(this.app, {
          animationDirection: SwipeDirections.DOWN,
        });
        break;
      case textAnimations.swipeleft:
        preset = new Swipe(this.app, {
          animationDirection: SwipeDirections.LEFT,
        });
        break;
      case textAnimations.swiperight:
        preset = new Swipe(this.app, {
          animationDirection: SwipeDirections.RIGHT,
        });
        break;
      case textAnimations.swipeup:
        preset = new Swipe(this.app, {
          animationDirection: SwipeDirections.UP,
        });
        break;
      case textAnimations.debug:
        preset = new DebugText(this.app);
        break;
      case textAnimations.zoom:
        preset = new Zoom(this.app);
        break;
      case textAnimations.cut:
      default:
        preset = new Cut(this.app);
    }

    this.setPreset(preset, model.animationPreset || textAnimations.cut);
  }
}
